<template>
    <div style="background:white; height:100%">
        <div style=" background:white;line-height:40px; border-bottom:2px solid #389;"> 
            <div style=" display:flex;width:1400px;padding-top:3px;line-height:30px;">
                <el-link @click="showRmk" :underline="false"><i class="iconfont icon-tishi" style="color:green;font-weight:700;font-size:20px"></i></el-link>
                <div style="width:70px">
                    <i class="iconfont icon-xinzeng" style="color:#409EFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link :disabled="addBool" @click="addRec" :underline="false" style="margin-top:0px;"><span style="font-size:13px;margin-right:15px;font-weight:600">新增</span></el-link>
                </div>
 
                <span style=" font-size:12px;margin-right:10px;">字段查询</span>
                <el-select v-model="selparam" size="small" placeholder="请选择列名" clearable  style="width:120px; " >
                    <span v-for="item in bomCol" :key='item.key'>
                        <el-option :label="item.title" :value="item.key" v-if="item.thide=='N'"></el-option>
                    </span>
                </el-select>
                <el-input :placeholder="input_hold" v-model="txtparam" @keyup.enter.native="inputQry" size="small" style="width:300px; height:30px; ">
                    <el-select v-model="oper" slot="prepend"   style="width:100px; " >
                        <span v-for="item in operArr" :key='item.IDSEQ'>
                            <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                        </span>
                    </el-select>
                    <el-button size="small" slot="append" icon="el-icon-search" @click="inputQry" ></el-button>
                </el-input> 
                <el-checkbox label="显示隐藏" class="large-checkbox" size="mini" true-label="Y" false-label="N" v-model="v_hide" @change="inputQry" style="margin-left:15px;color:red;font-size:12px;line-height:30px;margin-top:4px"></el-checkbox>
 
            </div>
        </div>  
        <el-table  :data="bomData" 
              border                            
              size="small"
              v-loading="v_loading"
              element-loading-text="加载中"
              element-loading-spinner="el-icon-loading"
              element-loading-background="rgba(255, 251, 255, 0.8)"
              :height="subHeight" 
              :row-key="getRowKey"
              ref="refbom"
              header-cell-class-name="clearPadding"
              :header-cell-style="{ 'color':'#389','text-align':'center'}"
              :cell-style="{padding:'3px','font-size':'12px',color:'black'}"
              class="custom-table-border"
              highlight-current-row
              style="overflow:auto;margin-top:1px;"> 
            <el-table-column label="序号" type="index" width="60" fixed>
                <template slot="header"  >
                    <el-link   @click="rowShow" style="font-size:12px;color:#fff"> 
                        <el-tooltip content=" 清除条件" effect="light">
                            <i class="iconfont icon-shanchu1" style="color:#409eff"></i>
                        </el-tooltip>
                    </el-link>
                </template>
            </el-table-column>   
            <el-table-column  v-for="(item,index ) in bomCol.filter(item=>item.thide=='N')" :key="index"
                :prop="item.key"
                :label="item.title"
                show-overflow-tooltip
                :align="item.align"                                  
                :sortable="item.sortable=='N'&&item.edcss!=='checkbox'"
                :min-width="item.width">
                <el-table-column  resizable :prop="item.key" :label="item.title" :align="item.align" show-overflow-tooltip :min-width="item.width">
                    <template slot="header" slot-scope="scope">
                        {{scope.row}}
                        <el-date-picker v-if="item.edcss=='date'" @change="inputQry" size="mini"  type="date" :clearable="false" v-model="v_row[item.key]"  value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker> 
                        <el-select v-else-if="item.key=='STFG'" v-model="v_row[item.key]"  size="mini" @change="inputQry" placeholder="请选择"  clearable style="width:100%">
                            <el-option label="是" value="N"></el-option>
                            <el-option label="否" value="Y"></el-option>
                        </el-select>  
                        <el-input type="number" @keyup.enter.native="inputQry" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"  placeholder="数字框" v-else-if="item.edcss=='number'" size="mini" v-model="v_row[item.key]" style="width:100%"> </el-input> 
                        <el-input :disabled="item.edcss=='image'" v-else @keyup.enter.native="inputQry"  v-model="v_row[item.key]" size="mini" placeholder="请输入" ></el-input> 
                    </template>
                    <template slot-scope="scope">
                        <el-link v-if="item.key=='IDNO'" :underline="false" @click="repBtn(scope.row)"><div style="color:#409eff;border-bottom:1px solid red;width:100%;text-align:left;font-size:14px ">{{scope.row[item.key]}}</div> </el-link>
                        <span v-else-if="item.key=='BOMTYNM'">
                            <el-tag  v-if="scope.row['BOMTY']=='480166'" size="mini" type="danger" effect="dark"  >{{scope.row['BOMTYNM']}}</el-tag>
                            <el-tag  v-else-if="scope.row['BOMTY']=='16212'" size="mini" type="success" effect="dark"  >{{scope.row['BOMTYNM']}}</el-tag> 
                            <el-tag  v-else  size="mini" type="info" effect="dark"  >{{scope.row['BOMTYNM']}}</el-tag> 
                        </span>
                        
                        <el-checkbox v-else-if="item.edcss=='checkbox'" class="large-checkbox" disabled true-label="Y"  false-label="N" v-model="scope.row[item.key]" style="width:100%"> &nbsp;</el-checkbox> 
                        <span v-else v-text="scope.row[item.key]" style="float:left"></span>
                    </template>
                </el-table-column> 
            </el-table-column>  
             <el-table-column
                fixed="right"
                label="状态操作"
                align="center"
                width="260">
                <template slot-scope="scope">
                    <i class="iconfont icon-fuzhi" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link   @click="cpRec(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:6px;">复制 </span></el-link>
                    <i class="iconfont icon-chakan" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                    <el-link :disabled="editBool" @click="editRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px ">查看</span></el-link>
                    <span v-if="scope.row.STFG==='N'">
                        <i class="iconfont icon-bianji" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="editRec(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px ">编辑</span></el-link>
                    </span> 
                    <span v-if="scope.row.STFG==='N'">
                        <i class="iconfont icon-shenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="stfgRec(scope.row,'Y',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px ">审核</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='Y'">
                        <i class="iconfont icon-fanshenhe" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="stfgRec(scope.row,'N',scope.$index)" :underline="false"  ><span style="font-size:12px;margin-right:5px  ">弃审</span></el-link>
                    </span>
                    <span v-if="scope.row.STFG==='N'">
                        <i class="iconfont icon-shanchu1" style="color:#409EFF;font-size:12px;margin-right:5px;"></i>
                        <el-link :disabled="editBool" @click="stfgRec(scope.row,'X',scope.$index)" :underline="false"  ><span style="font-size:12px; ">作废 </span></el-link>
                    </span> 
                </template>
            </el-table-column>  
        </el-table>
        <!-- 分页查询 -->
        <div style="margin-top: 5px; overflow: hidden;display:flex;background:white;font-size:12px">
            <div style="float: left;padding-left:4px;font-size:12px;">
                <Page :total="dataCount" :page-size="rowSize" show-total :current="current" @on-change="changePage"></Page>
            </div>
            <div style="line-height:30px;height:35px;width:500px;display:flex ; ">
                <div style="color:#606266; font-size:12px;width:35px;margin-left:15px">每页</div>
                <el-select v-model="rowSize" size="small" style="width:70px;"  @change="initPage">
                    <el-option 
                        v-for="item in pageList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                    </el-option>
                </el-select>
                <div style="color:#606266; margin-left:10px;font-size:12px;width:30px;">跳至</div>
                <el-input v-enter-number size="small" v-model="goPage" style="width:50px;"></el-input> 
                <span style="color:#606266; font-size:12px;margin-left:4px">页</span>
                <el-button @click="goNext" size="small" type="primary" style="width:40px;margin-left:15px;height:32px;">GO</el-button>
            </div>
        </div>
        <!-- 提示框 -->
        <el-dialog v-dialogDrag :show-close="false" :visible.sync="promptWin" width="400px" append-to-body :close-on-click-modal="false" :close-on-press-escape="false" >
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">
                <span style="line-height:35px;height:35px;font-size:14px;padding-left:5px;">提示</span>
            </div>
            <div style="line-height:30px;display:flex">
                <div style="width:40px; "><i class="iconfont icon-tishi1" style="color:#5cadff;font-size:36px"></i></div>
                <div style="font-size:12px;line-height:30px; ">{{prompt}}</div>
            </div>
            <span slot="footer"  >
                <el-button size="small" type="primary" @click="promptWin = false">确 定</el-button>
            </span>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag   :visible.sync="addWin" :width="dtlWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'35px'}">                
                <span style="line-height:36px;height:36px;font-size:15px;padding-left:5px;"><i class="iconfont icon-xuanze" style="margin-right:5px"></i>{{$route.meta.title}} ：{{ $LANG('0109', '明细资料') }}</span>
            </div> 
            <div style="height:89vh;overflow-y:auto">
                <div>
                <Form :model="bomRow" :label-width="110" ref="dtlform"  label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in bomCol" :key="index" >
                        <FormItem   :label="item.title"  :class="item.key=='RMK'?'item-width':'item-width'" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker size="medium" :clearable="false" :editable="false" :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="bomRow[item.key]" value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number size="medium" :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="bomRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-select size="medium" v-else-if="item.key==='MATNO'" v-model="bomRow[item.key]"  style="width:100%" filterable @change="matChg">
                                <div v-for="(item,index) in prdArr" :key="index"  >
                                    <el-option  :key="item.IDNO" :value="item.IDNO" :label="item.IDNO"  >
                                        <span style="float: left">{{ item.IDNO}}</span>
                                        <span style="float: left;margin-left:40px">{{ item.MATNM}}</span>
                                        <span style="float: right">{{ item.MATTYNM}}</span>
                                    </el-option>
                                </div>
                            </el-select> 
 
                            <el-select size="medium" :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="bomRow[item.key]"   style="width:100%">
                                <el-option v-for="(item,index) in comboArr[item.key]" :key="index" :label="item.CNAME" :value="item.CODE"></el-option>
                            </el-select>
                            <el-input size="medium" :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="bomRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
                </div>
                <div >
                    <split-pane  :min-percent='20' :default-percent='30' split="vertical">
                        <template slot="paneL">
                            <div style="line-height:30px;background:#808695;color:white;padding-left:5px;border-left:3px solid #f00">
                                BOM工序
                                <el-button  @click="saveSort" type="danger" plain size="mini" style="height:25px;margin-top:3px;margin-left:10px;border:1px solid green">
                                    <i class="iconfont icon-paixu-shengxu" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>重新排序
                                </el-button>
                                <el-button :disabled="addBool" @click="creJob" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:15px;border:1px solid green">
                                    <i class="iconfont icon-xiazai" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>导入工序
                                </el-button>
 
                                <el-button :disabled="addBool" @click="saveRec" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:15px;border:1px solid green">
                                    <i class="iconfont icon-baocun" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>保存工序
                                </el-button>
                                <el-button :disabled="addBool||!this.bomRow['CPMATNO']" @click="impMatList" type="primary" plain size="mini" style="height:25px;margin-top:3px;margin-left:15px;border:1px solid green">
                                    <i class="iconfont icon-baocun" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>导入复制产品物料
                                </el-button>
                            </div>
                            <el-table  :data="jobDtl" 
                                border                            
                                size="small"
                                :cell-style="{padding:'2px','font-size':'12px'}"
                                :height="dtlHeight" 
                                :row-key="getDtlKey"
                                @row-click="jobRowClick"
                                cell-class-name="clearPadding"
                                :row-class-name="tabRowClass"
                                class="custom-table-border"
                                ref="refjob"
                                highlight-current-row > 
                                <!-- <el-table-column label="序号" type="index" width="60"></el-table-column>  -->
                                <el-table-column v-for="(item,index ) in jobObj.filter(item=>item.thide=='N')"  :key="index"
                                    :prop="item.key"
                                    :label="item.title"
                                    show-overflow-tooltip
                                    :align="item.align"                                  
                                    :sortable="item.sortable=='N'"                                 
                                    :min-width="item.width">
                                    <template slot-scope="scope">   
                                        <input type="number"  @keydown ="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue"    v-if="item.disabled=='N'&&item.edcss=='number'" size="mini" v-model="scope.row[item.key]" style="width:96%">  
                                        <el-input size="mini"  v-else-if="item.edcss==='button'" v-model="scope.row[item.key]"  @focus="inputBtn(scope.row,scope.$index,item.key)" style="width:100%;border:1px solid #778899"></el-input>
                                        <span v-else v-text="scope.row[item.key]" ></span>
                                    </template>
                                </el-table-column> 
                                <el-table-column
                                    fixed="right"
                                    label="操作"
                                    align="center"
                                    width="150">
                                    <template slot-scope="scope">
                                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:11px;margin-right:5px;"></i>
                                        <el-link @click="jobDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px ">删除</span></el-link>
                                        <i class="iconfont icon-piliang" style="color:#409EFF;font-size:11px;margin-right:5px;"></i>
                                        <el-link @click="jobAllo(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px; ">分配物料</span></el-link>
 
                                    </template>
                                </el-table-column>  
                            </el-table>
                        </template>
                        <template slot="paneR">
                            <div style="line-height:30px;background:#808695;color:white;border-left:3px solid #f00">
                                <span style="font-size:13px;margin-right:15px;color:white;padding-left:6px;font-weight:600">工序 - 物料清单</span> 
 
                                <el-button :disabled="addBool" @click="saveMat" type="danger" plain size="mini" style="height:27px;margin-top:3px;margin-left:20px;border:1px solid green">
                                    <i class="iconfont icon-baocun" style=" font-size:12px;margin-right:3px;margin-left:-6px"></i>保存物料
                                </el-button>
                                <span style="color:#f1f2f3">【提示：在切换工序或再次点击分配物料时，如物料没有保存，请先保存，否则会丢失】</span>
                            </div>
                            <el-table  :data="dtlData" 
                                border              
   
                                class="custom-table-border draggable-table"           
                                size="small"
                                :cell-style="{padding:'2px','font-size':'12px'}"
                                :height="dtlHeight" 
                                :row-key="getItmKey"
                                :row-class-name="tabRowClass"
                                @row-click="getRowClick"
                                cell-class-name="clearPadding"
                                v-loading="t_loading"
                                element-loading-text="加载中"
                                element-loading-spinner="el-icon-loading"
                                element-loading-background="rgba(255, 251, 255, 0.8)"
                                ref="refdtl"
                                show-summary
                                :summary-method="getSummary"
                                highlight-current-row >   
                                <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N' &&item.key!=='SEL')" :key="index" 
                                    :prop="item.key"     
                                    :label="item.title"
                                    show-overflow-tooltip
                                    :align="item.align"                                  
                                    :sortable="item.key!=='RN' &&item.sortable=='N'"
                                    :min-width="item.width">
                                    <template slot-scope="scope"> 
                                        <span v-if ="saveFlag" >
                                            <el-checkbox v-if="item.edcss=='checkbox'" disabled true-label="Y" false-label="N" v-model="scope.row[item.key]"></el-checkbox>
                                            <span v-else v-text="scope.row[item.key]"></span>
                                        </span>
                                        <span v-else >
                                            
                                            <el-input @input="numChg(scope.row ,item.key)" type="number" @keydown.native="e=>e.returnValue=(['e','E','+'].includes(e.key))?false:e.returnValue" @keyup.down.native="nextLine(item.key,'down')" @keyup.up.native="nextLine(item.key,'up')"  :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter')"  size="mini" v-if="item.edcss=='number'" :controls="false"  v-model="scope.row[item.key]" style="width:100%"> </el-input>                                             
                                            <el-input @input="numBlur(scope.row ,item.key)" :ref="scope.$index+item.key" @keyup.enter.native="nextLine(item.key,'enter' )" @keyup.down.native="nextLine(item.key,'down' )" @keyup.up.native="nextLine(item.key,'up' )" v-else-if="item.disabled=='N'" size="mini" v-model="scope.row[item.key]" style="width:100%"> </el-input>     
                                            <span class="handle" v-else-if="item.key=='SORTBY'"><i class="iconfont icon-yidong"></i>{{scope.row[item.key] }}</span> 
                                            <el-input size="mini"  v-else-if="item.edcss==='button'" v-model="scope.row[item.key]"  @focus="inputBtn(scope.row,scope.$index,item.key)" style="width:100%;border:1px solid #778899"></el-input>
                                            <span v-else v-text="scope.row[item.key]"></span>
                                        </span>
                                    </template>
                                </el-table-column>                          
                                <el-table-column
                                    fixed="right"
                                    label="操作"
                                    align="center"
                                    width="70">
                                    <template slot-scope="scope">
                                        <i class="iconfont icon-shanchu" style="color:#409EFF;font-size:11px;margin-right:5px;"></i>
                                        <el-link :disabled="saveFlag" @click="dtlDel(scope.row,scope.$index )" :underline="false"  ><span style="font-size:12px;margin-right:5px ">删除</span></el-link>
                                    </template>
                                </el-table-column>  
                            </el-table>
                        </template>
                    </split-pane>
                </div>
            </div>
            <!-- <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <i v-if="bomRow['STFG']==='N'" style="margin-right:40px; color:red;font-size:28px; " class="iconfont icon-weishenhe3"> </i>
                    <i v-else-if="bomRow['STFG']==='Y'" style="margin-right:40px; color:red;font-size:28px; " class="iconfont icon-yishenhe1"> </i>
                    <el-button type="info" @click="addWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
 
                </span>
            </div> -->
        </el-dialog>
        <!-- 选择产品 -->
        <el-dialog  class="pub_dialog" v-if="selPrdWin" v-dialogDrag :visible.sync="selPrdWin" :width="dtlWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择产品</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <prdInfo  @child-matobj="prdSel" v-bind:v_type="sendVal"></prdInfo>
            </div>
        </el-dialog>
        <!-- 查看工序-物料 -->
        <el-dialog  class="pub_dialog" v-dialogDrag :visible.sync="qryJobMat" :width="dtlWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">查看工序-物料</span>
            </div>
            <div style="height:88vh;display:flex;overflow-y:auto; ">
                <div style="width:300px; ">
                    <el-tree :data="jobTree" 
                                :props="defaultProps" 
                                @node-click="jobClick" 
                                node-key="id"    
                                default-expand-all     
                                :style="{background:'#f7F8F9',overflow:'auto' ,height:'85vh'}"
                                highlight-current
                                ref="refmatree"
                                :expand-on-click-node="false">
                        <template v-slot="{node,data}">                                     
                            <span v-if="data.id ==0 "  >
                                <span  style="color:#409eff;font-size:14px;"><i class="iconfont icon-mokuai1" style="color:#409eff;font-size:18px;"></i> {{ node.label}} </span>
                            </span>                  
                            <span v-else  > 
                                <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="margin-right:5px;"></i> {{ node.label}} 【 {{data.id}} 】 </span>
                            </span>
                        </template>
                    </el-tree>
                </div>
                <div :style="{width:vwWidth}">
                    <el-table  :data="matAll" 
                                border                            
                                size="small"
                                class="custom-table-border"
                                :cell-style="{padding:'2px'}"
                                height="87vh" 
                                show-summary
                                :summary-method="getJobSum"
                                ref="refqry"
                                :row-key="getItmKey"
                                highlight-current-row >    
                        <el-table-column label="序号" type="index" width="55"></el-table-column>
                        <el-table-column  v-for="(item,index ) in dtlCol.filter(item=>item.thide=='N'&&item.key!=='SEL'&&item.key!=='SORTBY')"  :key="index"
                            :prop="item.key"
                  
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            :sortable="item.sortable=='N' &&item.key!=='RN'"
                            :min-width="item.width">
                        </el-table-column> 
                    </el-table>
                </div>
            </div>
        </el-dialog>
        <!-- 选择物料 -->
        <el-dialog  class="pub_dialog" v-dialogDrag  :visible.sync="selMatWin" :width="dtlWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择物料</span>
            </div>
            <div style="height:88vh;display:flex;overflow-y:auto; width:100%">
                <div style="width:300px;border:1px solid green;">
                    <el-input placeholder="请输入关键字进行过滤" v-model="filterText" size="medium"  ></el-input> 
                    <el-tree :data="treeData" 
                                :props="defaultProps" 
                                @node-click="handleNodeClick" 
                                node-key="id"    
                                default-expand-all     
                                :style="{background:'#fff',overflow:'auto' ,height:'82vh'}"
                                highlight-current
                                :filter-node-method="filterNode"
                                ref="eltree"
                                :expand-on-click-node="false">
                        <template v-slot="{node,data}">                                     
                            <span v-if="data.id ==0 "  >
                                <span  style="color:#409eff;font-size:14px;"><i class="iconfont icon-mokuai1" style="color:#409eff;font-size:18px;"></i> {{ node.label}} </span>
                            </span>                  
                            <span v-else  > 
                                <span style="color:#2b85e4;font-size:12px;"><i class="iconfont icon-fenzhijiedian" style="margin-right:5px;"></i> {{ node.label}} 【 {{data.id}} 】 </span>
                            </span>
                        </template>
                    </el-tree>
                </div>
                <div :style="{'width':matWidth}">
                    <div class="one-toolbar">
                        <span class="spanRow">
                            <span style=" font-size:12px;margin-right:10px;">字段查询</span>
                            <el-select v-model="selparam3"  placeholder="请选择列名" clearable size="small" style="width:150px;margin-left:5px; ">
                                <span v-for="item in matArr" :key='item.key'>
                                    <el-option :label="item.title" :value="item.key"></el-option>
                                </span>
                            </el-select>
                            <el-select v-model="oper3"  size="small" style="width:110px;margin-bottom:3px;margin-left:2px; ">
                                <span v-for="item in operArr" :key='item.IDSEQ'>
                                    <el-option :label="item.CNAME" :value="item.SUBNO"></el-option>
                                </span>
                            </el-select>
                            <el-input placeholder="请输入查询值" v-model="txtparam3" size="small" @keyup.enter.native="queryEvent" style="width:200px;margin-left:2px;margin-top:3px; ">
                                <el-button slot="append" icon="el-icon-search" @click="queryEvent" style="color:#409eff"></el-button>
                            </el-input> 
                            <el-button type="primary" icon="iconfont icon-chenggong1" size="mini" style="margin-left:10px" @click="alloMat">确定选择</el-button>
                        </span>
                    </div>
                    <el-table  :data="matData" 
                        border                            
                        disabled-hover
                        class="custom-table-border"
                        :cell-style="{padding:'2px'}"
                        :style="{'overflow':'auto','margin-top':'-7px','width':'100%'}"
                        size="small"
                        v-loading="m_loading"
                        element-loading-text="加载中"
                        element-loading-spinner="el-icon-loading"
                        element-loading-background="rgba(255, 251, 255, 0.8)"
                        cell-class-name="clearPadding"
                        height="80vh" 
                        ref="refmat" 
                        highlight-current-row>
                        <el-table-column label="序号" type="index" width="50"></el-table-column>
                        <el-table-column v-for="(item,index) in matArr.filter(item=>item.thide=='N')" :key="index" 
                            :prop="item.key"
                            :label="item.title"
                            show-overflow-tooltip
                            :align="item.align"                                  
                            :sortable="item.key!=='QTY'"
                            :min-width="item.width">
                            <template slot-scope="scope" >
                                <el-checkbox  v-if=" item.key==='SEL'" false-label="N" true-label="Y" v-model="scope.row.SEL" >&nbsp;</el-checkbox>
                                <el-input-number v-else-if="item.key=='QTY'"  :id="scope.$index+ item.key " :controls="false"   size="mini"  v-model="scope.row[item.key]" style="width:100%" ></el-input-number>
                                <span v-else v-text="scope.row[item.key]"></span>
                            </template>
                        </el-table-column>   
                    </el-table>  
                    <div style="margin-top: 3px; overflow: hidden;display:flex;background:white;font-size:12px">
                        <div style="float: left;padding-left:4px;font-size:12px;">
                            <Page :total="recCount" :page-size="rowSize" show-total :current="curpage" @on-change="chgMat"></Page>
                        </div>
                    </div>
                </div>
            </div>
        </el-dialog>
        <!-- 批量选择工序 -->
        <el-dialog  class="pub_dialog" v-dialogDrag :visible.sync="jobWin" :width="tabWidth" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="3vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">工序资料库</span>
            </div> 
            <div style="height:89vh;overflow-y:auto">
                <div class="one-toolbar"  >
                    <span class="spanRow" >
                    <i class="iconfont icon-xinzeng" style="color:#fFF;font-size:14px;margin-right:5px;margin-left:8px;"></i>
                    <el-link @click="jobAdd" :underline="false" ><span style="font-size:12px;margin-right:15px;color:white">新增工序</span></el-link>
                    <el-select v-model="selparam4" size="small" placeholder="请选择列名" clearable  style="width:150px;height:30px; " >
                        <span v-for="item in jobCol" :key='item.key'>
                            <el-option :label="item.title" :value="item.key" v-if="item.fhide=='N'"></el-option>
                        </span>
                    </el-select>
                    <el-input :placeholder="input_hold" v-model="txtparam4" @keyup.enter.native="getJobList" size="small" style="width:320px; height:30px;margin-top:3px; height:30px;">
                        <el-select v-model="oper4" slot="prepend"   style="width:100px;height:30px; " >
                            <span v-for="item in operArr" :key='item.IDSEQ'>
                                <el-option :label="item.CNAME" :value="item.SUBNO" ></el-option>
                            </span>
                        </el-select>
                        <el-button  slot="append" icon="el-icon-search" @click="getJobList" ></el-button>
                    </el-input> 
                    <el-button type="primary" icon="iconfont icon-chenggong1" size="mini" style="margin-left:30px" @click="alloRec">确定选择</el-button>
                    </span>
                </div>
                <el-table  :data="jobData" 
                    border                            
                    size="small" 
                    :cell-style="{padding:'2px'}"
                    :height="jobHeight" 
                    class="custom-table-border"
                    :row-key="getRowKey"
                    ref="refreq"
                    highlight-current-row
                    style="overflow:auto;margin-top:-4px;">                    
                    <el-table-column  v-for="(item,index) in jobCol.filter(item=>item.thide==='N' && item.key!=='STFG'&& item.key!=='JOBNUM')" :key="index"
                        :prop="item.key"
                        :label="item.title"
                        :fixed="item.key=='RN'"
                        show-overflow-tooltip
                        :align="item.align"                                  
                        :sortable="item.sortable=='N' &&item.key!=='RN'"
                        :min-width="item.width">
                    </el-table-column>
             
                    <el-table-column
                        fixed="left"
                        label="选择"
                        align="center"
                        width="70">
                        <template slot-scope="scope">
                            <el-checkbox  false-label="N" true-label="Y" v-model="scope.row['SEL']" >&nbsp;</el-checkbox>
                        </template>
                    </el-table-column>  
                </el-table>
            </div>
        </el-dialog>
        <!-- 新增、编辑表单 -->
        <el-dialog class="pub_dialog" v-dialogDrag :show-close="false" :visible.sync="addJob" :width="tabWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;"> 新增记录  </span>
            </div> 
            <div style=" overflow-y:auto">
                <Form :model="jobRow" :label-width="110" ref="jobform"   label-position="right" inline  :rules="ruleValidate">  
                    <span v-for="(item,index) in jobCol" :key="index" >
                        <FormItem   :label="item.title"  class="item-width" v-if="item.fhide==='N'" :prop="item.key"  >                  
                            <el-date-picker :disabled="saveFlag" type="date"  v-if="item.edcss==='date'" v-model="jobRow[item.key]"   value-format="yyyy-MM-dd" style="width:100%" ></el-date-picker>   
                            <el-input-number :disabled="saveFlag" :precision="item.dotnum"  v-else-if="item.edcss==='number'" v-model="jobRow[item.key]" style="width:100%" ></el-input-number>   
                            <el-select :disabled="saveFlag" v-else-if="item.edcss==='select'" v-model="jobRow[item.key]"   style="width:100%">
                                <el-option v-for="(it,ind) in comboArr[item.key]" :key="ind" :label="it.CNAME" :value="it.CODE"></el-option>
                            </el-select>
                            <el-input :disabled="saveFlag ||item.disabled==='Y'?true:false" type="text" v-else   v-model="jobRow[item.key]" ></el-input>
                        </FormItem>
                    </span>
                </Form>
            </div>
            <div style="height:35px;line-height:30px;border-top:2px solid #ccc;padding-top:4px; " >
                <span style="float:right">
                    <el-button type="info" @click="addJob=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
                    <el-button @click="saveJob" size="small" type="primary" style="margin-left:30px;" icon="iconfont icon-baocun"  > 保存 </el-button>                 
                </span>
            </div>
        </el-dialog>
        <!-- 备注选择 -->
        <el-dialog v-dialogDrag :visible.sync="rmkWin" width="800px" append-to-body  :close-on-click-modal="false" :close-on-press-escape="false" top="1vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">说明</span>
            </div> 
            <div style="height:200px;overflow-y:auto">
                    <div style="line-height:30px; font-size:13px" v-for="(item,index) in rmkArr" :key="index">{{item.CNAME}}</div>   
            </div>
            <span slot="footer"  >
                <el-button type="info" @click="rmkWin=false" size="small"  icon="iconfont icon-shanchu">  取消</el-button>
            </span>
        </el-dialog>
        <!-- 引用报表 -->
        <el-dialog  v-dialogDrag   :visible.sync="repDlg" width="550px" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表参数</span>
            </div> 
            <rep-win v-bind:v_idno ="v_idno" v-bind:v_replist="v_replist" v-bind:v_corpid="v_corpid" @child-exit="repDlg=false" @child-sure="repShow"></rep-win>                
        </el-dialog>
        <!-- report preview -->
        <el-dialog class="pub_dialog" v-dialogDrag  :visible.sync="repWin" :width="dtlWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="4vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">报表预览</span>
            </div> 
            <div style="height:88vh;overflow-y:auto">
                <iframe :src="repUrl" frameborder="0" style="width: 100%; height: 100%"></iframe>
            </div>
        </el-dialog>
        <!-- 引用选择框 -->
        <el-dialog  v-dialogDrag v-if="btnWin" :visible.sync="btnWin" :width="dtlWidth" :close-on-press-escape="false" :close-on-click-modal="false" append-to-body top="6vh">
            <div slot="title" :style="{'background':'#409eff','color':'white','height':'40px'}">
                <span style="line-height:40px;height:40px;font-size:16px;padding-left:5px;">选择记录</span>
            </div> 
            <pub-win v-bind:tabCol ="tableCol" v-bind:v_cond="v_cond" v-bind:v_table="v_table" v-bind:v_key2="v_key2" v-bind:v_value2="v_value2" @child-exit="btnWin=false" @child-sure="btnSure"></pub-win>                
        </el-dialog>
        <el-dialog :visible.sync="loadWin" width="53px" append-to-body :show-close="false" :close-on-press-escape="false" :close-on-click-modal="false">
            <el-image  src="/assets/authorize/loading.gif" ></el-image>  
        </el-dialog>
    </div>
</template>
<script>
import {getBaseData,getTabColOrData} from '../../api/user'; 
import { getDate} from '../../api/Select' 
import prdInfo from '../datamgt/production.vue'
import repWin from '../datamgt/repWin.vue'  
import pubWin from '../datamgt/pubwin.vue'
import Sortable from 'sortablejs'  
export default {
    name:'bom_bill',
    data () {
        return {
            loadWin:false,
            repUrl:'',
            repWin:false,
            rmkWin:false,
            tmplRmk:'',
            matAll:[],
            jobObj:[],
            jobDtl:[],
            alloData:[],
            jobWin:false,
            addJob:false,
            qryJobMat:false,
            jobRow:{},
            dtlRow:{},
            textShow:{},
            rmkArr:[],
            editIndex:-1, //当前编辑行index
            sendVal:'PRD',
            treeData:[],
            jobTree:[],
            jobArr:[],
            nodeLabel:'物料类别',
            treeid:'0' , //'1021',  
            selPrdWin:false,
            comboArr:[],
            selMatWin:false,
            promptWin:false,
            v_cond:'',
            jobData:[],
            prdRow:{},
            curpage:1,
            recCount:0,
            filterText:'',
            v_hide:'N',
            rowDtl:{},
            v_usernm:this.$cookies.get('v_usernm'), //api 请求用户
            stfgSet:'ALL',
            prdArr:[],
            prompt:'',
            input_hold:'请输入内容...',
            ruleValidate:{},
            defaultProps: {  //el-tree 默认字段属性
                children: 'children',
                id:'id',
                icon:'icon',
                label: 'label'
            },
 
            selparam3:'MATNM',
            oper3:'like',
            txtparam3:'',
            selparam4:'JOBNM',
            oper4:'like',
            txtparam4:'',
            selparam:'MATNO',
            txtparam:'',
            bomRow:{},
            prdFlag:'create',
            goPage:'',
            rowIdseq:'',
            bomData:[],
            cfmBool:false, //审核 权限
            addBool:false, //新增 权限
            editBool:false, //编辑权限
            cancelBool:false, //作废权限
            matArr:[],
            v_loading:false,
            t_loading:false,
            m_loading:false,
            current:1,
            saveFlag:false,
            v_joblst:'',
            allList:[], //询价单集合
            dtlData:[],
            matData:[],
            addWin:false,
            v_username:this.$cookies.get('v_telno'), //api 请求用户
            
            v_corpid:this.$cookies.get('v_corpid') , //员工公司ID
            v_url:'xuper_auth/getTableRecMany' , //api请求路径   
            pageList: [ {
                value: 50,
                label: '50'
                }, {
                value: 100,
                label: '100'
                }],
            allMat:[],
            dataCount:0,
            rowSize:50,
            dtlCol:[],
            matCol:[],
            bomCol:[],
            operArr:[],
            v_idseq:'',
            jobCol:[],
            v_jobno :'',
            deptArr:[],
            oper:'like',
            v_row:{},
            v_lstseq :'',
            dtlIndex:'',
            chkIndex:'',
            repDlg:false,
            v_idno:'',
            v_replist:[],
            repArr:[],
            stfgBool:true,
            notNull:[],
            v_key:'',
            prodCol:[],
            v_table:'',
            tableCol :[],
            v_key2 :'',
            v_value2 :'',
            v_tabIndex:'',
            v_tabRow:{},
            btnWin:false,
        }
    },
    components: {
        prdInfo,  //产品列表
        repWin,
        pubWin,
    },
    watch: {
        filterText(val) {
            this.$refs.eltree.filter(val);
        }
    },
    computed: {
        subHeight: function() {
            return (window.innerHeight - 160) + 'px';
        }, 
        jobHeight: function() {
            return (window.innerHeight - 155) + 'px';
        }, 
        matWidth: function() {
            return (window.innerWidth - 420) + 'px';
        }, 
        dtlWidth: function() {
            return (window.innerWidth - 100) + 'px';
        },
        tabWidth: function() {
            return (window.innerWidth - 320) + 'px';
        },  
        dtlHeight: function() {
            return (window.innerHeight - 285) + 'px';
        }, 
        vwWidth: function() {
            return (window.innerWidth - 340) + 'px';
        }, 
    },
    mounted () {
        this.showkey()
        //操作符
        getBaseData(this.v_url,'PARENTNO','15995','','','v_sys_base','').then(res=>{
            this.operArr =res.result
        });  
        //工序中心
        getBaseData(this.v_url,'corpid',this.v_corpid,'','','v_bs_job','').then(res=>{
            this.jobArr =res.result
        })
        //产品
        getBaseData(this.v_url,'corpid',this.v_corpid,'modelno','PRD','v_bs_mat','').then(res=>{
            this.prdArr =res.result
        })
        getBaseData('xuper_auth/getTableRecMany','PARENTNO','398573','','','v_sys_base',' order by sortby,idseq').then(res=>{
            this.rmkArr =res.result 
        })
        this.comSelect()
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','15754','V_USER_MOD_REP','').then(res=>{
            this.repArr =res.result
        })
         //用户权限表
        getBaseData(this.v_url,'userno',this.v_username,'frmidseq','15754','v_sys_user_priv','').then(res=>{           
            if (this.v_admin==='N') { //表示有权限控制
                let row =res.result[0]
                if (row.ISADD==='N'){ //新增
                    this.addBool=true
                }if (row.ISUPD==='N'){ //修改
                    this.editBool=true
                }if (row.ISDEL==='N'){ //删除
                    this.delBool=true
                }if (row.ISCFM==='N'){ //审核
                    this.cfmBool=true
                }if (row.ISCANCEL==='N'){ //作废
                    this.cancelBool=true
                }
            }
        })    
         //动态生成表单验证规则
        getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15754','LSTSEQ','1','NOTNULL','Y').then((res) => {
            let ruleObj={}
            let ruleVal=[]
            this.notNull = res.result
            res.result.forEach(item => {
                let v_fldnm =item.FLDNM
                let obj1={required:true,message:v_fldnm+'不能为空',trigger: 'blur'}
                ruleVal =[]
                ruleVal.push(obj1)
                ruleObj[item.FLDNO]=ruleVal                  
            });
            this.ruleValidate =ruleObj
        })
        this.getJobList()
        this.queryEvent()
        
    },
    created () {
        if (this.v_username){
            this.getTabCol() //表列集合
            this.getBomList('')  
            this.getData()  
        }else{
            let routeUrl = this.$router.resolve({
                path: '/',
                query: {lang:this.LANG },
            });
            window.open(routeUrl.href, '_self'); 
        }
    },
    methods: {
        getJobSum(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if( column.property==='AMT' ||column.property==='QTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(4)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        getSummary(param){
            const {columns ,data}=param
            const sums=[]
            columns.forEach((column,index)=>{
                if (index===0){
                    sums[index]='合计'
                    return
                }
                const values =data.map(item=>Number(item[column.property]));
                if( column.property==='AMT' ||column.property==='QTY'){
                    sums[index]=values.reduce((prev,curr)=>{ //为数组中每一个元素依次执行回调函数
                        const value=Number(curr)
                        if(!isNaN(value)){
                            return Number(Number(prev) +Number(curr) ).toFixed(4)
                        }else{
                            return prev
                        }
                    },'')
                }
            })
            return sums
        },
        rowShow(){
            Object.keys(this.v_row).forEach(item=>{
                this.v_row[item] =''
            })
            this.getBomList('')
        } ,
        //字段查询
        inputQry(){
            let cond_=''
            if (this.selparam){ //列1
                if (this.oper==='like'){
                    cond_=cond_+' and  '+this.selparam+'  like  \'%' + this.txtparam+'%\' '
                }else if (this.oper==='!='){
                    cond_=cond_+' and  '+this.selparam+' is null '  
                }else{
                    cond_=cond_+' and  '+this.selparam  +this.oper+' \''+this.txtparam+'\' '
                }
            }
 
            let v_cond ='' ,v_edcss=''
            Object.keys(this.v_row).forEach(item=>{
                if (this.v_row[item] ){
                    this.bomCol.some(it=>{
                        if (it['key']== item){
                            v_edcss =it['edcss']
                        }
                    })
                    if (v_cond ){
                        if (v_edcss =='number'){
                            v_cond =v_cond +' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond =v_cond +' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }else{
                        if (v_edcss =='number'){
                            v_cond = ' and '+item+'>='+  this.v_row[item] 
                        }else{
                            v_cond = ' and lower('+item+') like \'%'+ (this.v_row[item]).toLowerCase().trim()+'%\''
                        }
                    }
                }
            })
            this.getBomList(v_cond+cond_)
        },
        numBlur( row , key){
            if (key =='POSITION'){
                let v_arr =row['POSITION'].split(',')
                if (v_arr.length ==0) {
                    row['QTY'] =1
                }else{
                    row['QTY'] =v_arr.length
                }
            }
        },
        numChg(row,key){
            if (key =='QTY'){
                row['AMT'] =(Number(row['QTY']) * Number(row['POPRC']) ).toFixed(4)
            }
        },
        btnSure(obj){
            if (this.v_key =='MATNO'){
                this.dtlData.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ MATNO:obj['IDNO'],MATNM:obj['MATNM'],SPECNM:obj['MATDESC'],MATTYNM:obj['MATTYNM'],UNITNM:obj['UNITNM']  } ))
            }else if (this.v_key =='JOBNO'){
                this.jobDtl.splice(this.v_tabIndex,1, Object.assign(this.v_tabRow,{ JOBNO:obj['IDNO'],JOBNM:obj['JOBNM'],WKNM:obj['WKNM'] } ))
            }  
            this.btnWin =false
        },
        inputBtn(row,index,key){
            this.v_key =key    
            if (key =='MATNO'){ //物料
                this.v_tabRow =JSON.parse(JSON.stringify(row))
                this.v_tabIndex =index
                this.v_table ='v_bs_mat'
                this.tableCol =this.prodCol
                this.v_key2 ='modelno'
                this.v_value2 = 'MAT'
                this.v_cond=' and ishide=\'N\''
                this.btnWin =true
            }else if (key =='JOBNO'){ //工序
                this.v_tabRow =JSON.parse(JSON.stringify(row))
                this.v_tabIndex =index
                this.v_table ='v_bs_job'
                this.tableCol =this.jobCol
                this.v_key2 =''
                this.v_value2 = ''
                this.v_cond=''
                this.btnWin =true
            }     
        },
        //复制记录
        cpRec(row,index){
            this.$confirm('你确定要复制此记录吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{    
                this.loadWin =true
                this.dtlData=[]
                this.jobDtl =[]
                this.bomRow={IDSEQ:'',IDNO:'',STFG:'N',MATTY:row['MATTY'],MATNO:row['MATNO'],MATNM:row['MATNM'],MATTYNM:row['MATTYNM'],
                    SPECNM:row['SPECNM'],UNITNM:row['UNITNM'],VER:1,WKNM:row['WKNM'],WKNO:row['WKNO'],BOMTYNM:row['BOMTYNM'],BOMTY:row['BOMTY']
                    ,QTY:row['QTY'],RMK:'',CPMATNO:row['MATNO']}
                //明细记录
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'idseq', p_value:row['IDSEQ'], p_table:'V_bs_bomJOB'},
                }).then(res=>{ 
                    if (res.result.length>0){
                        res.result.forEach(it=>{
                            this.jobDtl.push({IDSEQ:'',LSTSEQ:'',REFIDSEQ:it['IDSEQ'],REFLSTSEQ:it['LSTSEQ'],JOBNUM:it['JOBNUM'],JOBNO:it['JOBNO'],JOBNM:it['JOBNM'],WKNM:it['WKNM']})
                            // this.$axios({   
                            //     method: 'post',
                            //     url:'xuper_auth/getBaseData',
                            //     data: {p_key:'idseq', p_value:row['IDSEQ'],p_key2:'lstseq', p_value2:it['LSTSEQ'], p_table:'V_bs_bomdtl'},
                            // }).then(res=>{ 
                            //     if (res.result.length>0){
                            //         res.result.forEach(item=>{
                            //             this.dtlData.push({IDSEQ:'',LSTSEQ:'0',SORTBY:item['SORTBY'],MATTY:item['MATTY'],MATNO:item['MATNO'],CMATNM:item['CMATNM']
                            //                 ,MATTYNM:item['MATTYNM'],SPECNM:item['SPECNM'],BOMUNITNM:item['BOMUNITNM'],QTY:item['QTY'],POSITION:item['POSITION']
                            //                 ,POPRC:item['POPRC'],UNITNM:item['UNITNM'],AMT:item['AMT'],RMK:item['RMK'],ITMSEQ:'',JOBNO:it['JOBNO']
                            //             })
                            //         })                            
                            //     }
                            // })
                        })
                    }
                    this.loadWin =false
                    this.addWin=true
                })
                // this.$axios({
                //     method: 'post',
                //     url:'xuper_auth/copyRecord',
                //     data: {p_fridseq:row['IDSEQ'],p_action:'BOM',p_toidseq:'' },
                // }).then(res=>{
                //     if (res.code=='200'){
                //         this.addWin=true
                //         let v_idseq =res.idseq
                //         this.$axios({   
                //             method: 'post',
                //             url:'xuper_auth/getBaseData',
                //             data: {p_key:'idseq', p_value:v_idseq, p_table:'bs_bom'},
                //         }).then(res=>{ 
                //             if (res.code=='200'){
                //                 this.bomRow =res.result[0]
                //                 //明细
                //                 this.getDtlList(v_idseq)
                //             }else{
                //                 this.promptWin =true
                //                 this.prompt =res.result
                //             }
                //         })
                //     }else{
                //         this.promptWin =true
                //         this.prompt ='有空记录，请完善，现不能复制'
                //     }
                // })
            }).catch(()=>{}) 
        },
        impMatList(){
            if (this.bomRow && this.bomRow['IDSEQ']){
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/copyRecord',
                    data: {p_fridseq:this.bomRow['IDSEQ'],p_action:'BOM',p_toidseq:'' },
                }).then(res=>{
                   this.getDtlList(this.bomRow['IDSEQ'])
                })
            }else{
                this.promptWin =true
                this.prompt ='请先保存记录，再导入复制产品的物料'
            }
        },
        //报表运行
        repBtn(row){
            this.repDlg =true
            this.v_idno =row['IDNO']
            this.v_replist =this.repArr
        },
        repShow(row){
            if (!row['REPNO']){
                this.promptWin =true
                this.prompt ='请选择报表'
            }else{
                this.repWin =true
                this.repDlg =false
                this.repUrl =this.$store.state.repUrl+ row['REPNO']+'&p_corpid='+row['CORPID']+'&p_idno='+row['IDNO']+'&p_userid='+this.v_username+getDate('full')
            }
 
        },
        //禁止 键盘上、下键改变值
        showkey() {
            document.onkeydown = function () {
                if (window.event.keyCode === 38 || window.event.keyCode === 40) {
                    window.event.returnValue = false;
                }
            }
        },
        tabRowClass({row,rowIndex}){  //为 table数据添加 index 字段
            row.index =rowIndex
        },
        getRowClick(row){
            this.chkIndex =row.index
        },
        //表格行 按回车键 到下一行
        nextLine(key,val ){ 
            if (val =='enter'){
                if (key =='RMK'){
                    this.chkIndex = this.chkIndex +1
                    let v_count=''
                
                    v_count =this.dtlData.length
                  
                    if (this.chkIndex >=v_count) {
                        this.chkIndex =0
                    }
                    this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])
                    //if (reftab=='refpos'){
                        this.$refs[ this.chkIndex+'QTY'][0].focus()  
                   // } 
                }else{
                    let v_col = this.dtlCol.filter(item=>item.thide=='N'&&item.disabled=='N'&&item.edcss!=='checkbox')
                    v_col.some((item,index)=>{
                        if (item.key==key){
                            this.$refs[ this.chkIndex+ v_col[index+1].key][0].focus()  
                        }
                    })
                } 
            }else if (val =='down'){
                this.chkIndex = this.chkIndex +1       
                if (this.chkIndex >=this.dtlData.length) {
                    this.chkIndex =0
                }
                this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])           
                this.$refs[this.chkIndex+key][0].focus()             
            }else if (val =='up'){
                this.chkIndex = this.chkIndex -1
                if (this.chkIndex <=0) {
                    this.chkIndex =0
                }                            
                this.$refs[ this.chkIndex+key][0].focus()  
                this.$refs['refdtl'].setCurrentRow(this.dtlData[this.chkIndex])       
            }                    
        },
        showRmk(){
            this.rmkWin =true
        },
        matChg(val){
            let v_bool =false
            this.bomData.some(item=>{
                if (item['MATNO']==val){
                    v_bool =true
                }
            })
            if (v_bool){
                this.bomRow['MATNO'] =''
                this.bomRow['MATNM'] =''
                this.bomRow['MATTYNM'] =''
                this.bomRow['SPECNM'] =''
                this.promptWin =true
                this.prompt ='此产品已存在BOM ，请核查'
            }else{
                this.prdArr.some(item=>{
                    if (item['IDNO']==val){
                        this.bomRow['MATNM'] =item['MATNM']
                        this.bomRow['MATTYNM'] =item['MATTYNM']
                        this.bomRow['SPECNM'] =item['MATDESC']
                    }
                })   
            }
               
        },
        //查看工序树结构
        getJobTree(idseq) {  
            var vm=this;
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'V_JOB_TREE',p_cond:' and corpid=\''+this.v_corpid+'\' and (IDSEQ=-1 OR idseq='+idseq+') ORDER BY SORTBY'}
            }).then(function(res){                  
                vm.jobTree =res.result  
                vm.$nextTick(()=>{
                    vm.$refs.refmatree.setCurrentKey(0)  
                })         
            })                              
        },
        jobClick(data){
            if (data.id ==0){ //根节点
               getTabColOrData(this.v_url,'V_BOM_MATGP', 'idseq',this.v_joblst,'','','','',' order by matno' ).then((res) => {         
                    this.matAll = res.result
                    this.$nextTick(()=>{
                        this.$refs['refqry'].doLayout()
                    })
                }) 
            }else{
                getTabColOrData(this.v_url,'v_bs_bomdtl','lstseq',data.id,'idseq',this.v_joblst,'','',' order by matno' ).then((res) => {         
                    this.matAll = res.result
                    this.$nextTick(()=>{
                        this.$refs['refqry'].doLayout()
                    })
                })
            }
        },
        //物料保存
        async saveMat(){
            if(this.v_idseq){
                let v_dup =this.dtlData.map(item=> item.MATNO )  
                //const v_set  =Array.from(new Set(v_dup.map(JSON.stringify))).map(JSON.parse) 
                let v_dupBool= v_dup.filter((item, index) => v_dup.indexOf(item) !== index)
                if (v_dupBool.length>0){
                    this.promptWin =true
                    this.prompt ='异常:' +JSON.stringify(v_dupBool)+' 有重复的物料编码 ，请核查'    
                    return
                }
                this.loadWin=true 
                // forEach 不支持异步等待 不能直接用 forEach + async/await 只能用 for 循环
                const v_confirm =this.dtlData.map(async (item,index)=>{
                    let v_index =index+1
                    let v_row =Object.assign(item,{IDSEQ:this.v_idseq,LSTSEQ:this.v_lstseq,SORTBY:v_index})
                    return await this.$axios({
                        method: 'post',
                        url:'xuper_auth/tableBodySave2',
                        data: {p_json:JSON.stringify(v_row ), p_table:'BS_BOMDTL' },
                    }).then(res=>{
                        item['SORTBY'] =v_index
                    })
                })
                 
                const results = await Promise.all(v_confirm).then(()=>{
                    this.loadWin =false
                    getTabColOrData(this.v_url,'v_bs_bomdtl','lstseq',this.v_lstseq,'idseq',this.v_idseq,'','','' ).then((res) => {         
                        this.dtlData = res.result
                        this.$message({message: '已保存物料',type: 'success',center:true,duration:2000})
                    })  
                }) 
                //更新主表
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:this.v_idseq, p_table:'BS_BOM',p_cond:' set upduser=\''+this.v_usernm+'\',upddttm=\'' +getDate('full')+'\''},
                })
               
            }else{
                this.prompt='请选择一条工序记录'
                this.promptWin=true
            }
        },
        jobRowClick(row){
            if (row['IDSEQ']){
                this.dtlData =[]
                this.t_loading =true
                getTabColOrData(this.v_url,'v_bs_bomdtl','lstseq',row['LSTSEQ'],'idseq',row['IDSEQ'],'','',' order by sortby,matno' ).then((res) => {         
                    this.dtlData = res.result
                    res.result.forEach((item,index)=>{
                        item['SORTBY'] =index+1
                    })
                    this.$nextTick(()=>{
                        this.t_loading =false
                    })
                })
                this.v_idseq =row['IDSEQ']
                this.v_lstseq=row['LSTSEQ']
            }
        },
        //分配物料
        jobAllo(row){
            if (row.LSTSEQ) {
                this.selMatWin =true
                this.v_jobno =row.JOBNO
                this.$nextTick(()=>{
                    this.$refs.eltree.setCurrentKey(this.treeid) 
                })
            }else{
                this.promptWin =true
                this.prompt ='此工序对应的主键为空，请先保存工序'
            }
        },
        creJob(){
            this.jobWin =true
        },
        //物料选择确定
        alloMat(){
            let v_bool =true ,v_exist =true
            let matArr =[], v_dupmat=''
            this.matData.forEach((item,index)=>{
                if (item['SEL']=='Y'){
                    v_bool =false
                    matArr.push({MATNO:item['IDNO'],MATNM:item['MATNM'],MATTYNM:item['MATTYNM'],MATDESC:item['MATDESC'],UNITNM:item['UNITNM'],QTY:item['QTY'] } )
                    this.matData.splice(index,1,Object.assign(item,{SEL:'N'}))
                }
            })
            if (v_bool){
                this.prompt='请勾选物料'
                this.promptWin=true
            }else{
                matArr.forEach(item=>{
                    v_exist =true
                    this.dtlData.some(mat=>{
                        if (mat['MATNO'] ==item['MATNO']){                           
                            v_exist =false
                        }
                    })
                    if (v_exist){
                        this.dtlData.push({JOBNO:this.v_jobno,MATNO:item['MATNO'],MATNM:item['MATNM'],SPECNM:item['MATDESC'],MATTYNM:item['MATTYNM'],UNITNM:item['UNITNM'],QTY:item['QTY']})
                    }else{
                        v_dupmat=v_dupmat+' '+item['MATNO']
                    }
                })
                this.selMatWin =false
                console.log('dup00:'+v_dupmat)
                if (v_dupmat!==''){
                    this.promptWin =true
                    this.prompt='以下物料：'+v_dupmat+' 已分配！'
                }
                
            }
        },
        //工序选择确定
        alloRec(){
            let v_bool =true ,v_exist =true
            let jobArr =[]
            this.jobData.forEach((item,index)=>{
                if (item['SEL']=='Y'){
                    v_bool =false
                    jobArr.push({JOBNO:item['IDNO'],JOBNM:item['JOBNM'],JOBDESC:item['JOBDESC'],WKNM:item['WKNM'] } )
                    this.jobData.splice(index,1,Object.assign(item,{SEL:'N'}))
                }
            })
            if (v_bool){
                this.prompt='请勾选工序'
                this.promptWin=true
            }else{
                jobArr.forEach((item,index)=>{
                    let v_index =Number(this.jobDtl.length+1)
                    this.jobDtl.push({IDSEQ:'',LSTSEQ:'',JOBNO:item['JOBNO'],JOBNM:item['JOBNM'],WKNM:item['WKNM'],JOBNUM:v_index})
                })
                this.jobWin =false
            }
        },
 
        //保存工序
        saveJob(){
            //发起保存请求   
            this.$refs['jobform'].validate((valid) => {
                if (valid) {
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.jobRow,{CORPID:this.v_corpid})), p_table:'bs_job',frmid:'16521'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            this.addJob =false   
                            this.getJobList()
                             
                        }else{
                            this.promptWin=true
                            this.prompt=res.result
                        }        
                    }) 
                }
            })
        },
        //工序清单 
        getJobList(){
            let cond_=''
            if (this.selparam4){ //列1
                if (this.oper4==='like'){
                    cond_=cond_+' and lower('+this.selparam4+') like lower(\'%' + this.txtparam4+'%\')'
                }else{
                    cond_=cond_+' and lower('+this.selparam4+')' +this.oper4+' lower(\''+this.txtparam4+'\')'
                }
            }
            let vm =this
            getTabColOrData(this.v_url,'v_bs_job','','','CORPID',this.v_corpid,'','',cond_ ).then((res) => { 
                this.jobData =res.result 
            })
        },
   
        //节点过滤
        filterNode(value, data) {
            if (!value) return true;
            return data.label.indexOf(value) !== -1||data.id.indexOf(value) !== -1
        },
        //节点点击
        handleNodeClick(data ){
   
            this.nodeLabel=data.label;            
            this.treeid =data.id
            this.queryEvent()
        },
        queryEvent(){
            let cond_=''
            if (this.selparam3){ //列1
                if (this.oper3==='like'){
                    cond_=cond_+' and lower('+this.selparam3+') like lower(\'%' + this.txtparam3+'%\')'
                }else{
                    cond_=cond_+' and lower('+this.selparam3+')' +this.oper3+'lower(\''+this.txtparam3+'\')'
                }
            }
            //if(this.treeid!=='0'){
                cond_= cond_+ ' and (matty=\''+this.treeid+'\' or matty in (select code from bs_type start with parentno=\''+this.treeid+'\' CONNECT BY PRIOR CODE=PARENTNO))  '  
            //} 
            this.getMatList(cond_)
        },
        //物料明细
        getMatList(cond){
            this.m_loading =true
            //获取所有物料记录且初始化分页记录         
            this.$axios({   
                method: 'post',
                url:'xuper_auth/getBaseData',
                data: {p_key:'MODELNO', p_value:'MAT',p_key2:'corpid', p_value2:this.v_corpid,p_cond:cond+' and ishide=\'N\'' ,p_table:'V_BS_mat'},
            }).then(res=>{ 
                this.allMat=res.result
                this.initMat()
                this.m_loading=false
                for(let k=0; k<this.allMat.length;k++){
                    this.dtlData.some(item=>{
                        if (item['MATNO'] ==this.allMat[k]['IDNO']){
                            this.allMat.splice(k,1,Object.assign(this.allMat[k],{SEL:'Y'}) )
                        }
                    })
                }
            }) 
        },
        //左边菜单
        getData() {  
            var vm=this;
            this.$axios({
                method: 'post',
                url:'xuper_auth/getElTreeData',
                data: {p_table:'v_mat_TYPE',p_cond:' and corpid=\''+this.v_corpid+'\''}
            }).then(function(res){                  
                vm.treeData =res.result   
                       
            })                              
        },
        editCurrRow(rowId,str){
            this.editIndex=rowId //不加此，整个列都会一块变成可编辑
            this.textShow={}
            this.textShow[str]=true
            let id=rowId +str
            //也可以用 this.$nextTick, 个人感觉加个0.1秒的延时比下次渲染灵活一点
            setTimeout(()=>{
                document.getElementById(id).focus()
            },100)
        },
 
        //动态赋值下拉框
        comSelect(){  
            this.$axios({
                method:'post', 
                url: 'xuper_auth/getBaseData' ,
                data:{p_table:'v_sys_form_fld', p_cond:' and idseq in (15754,16521) and lstseq in (1,2 )' ,p_key3:'edcss',p_value3:'select'},
            }).then(res =>{
                if (res.result.length>0){
                    for(let k=0;k<res.result.length;k++){
                        getBaseData('xuper_auth/getBaseData','parentno',res.result[k].COMBO ,'','','v_sys_base','').then(res2=>{
                            this.comboArr[res.result[k].FLDNO] =res2.result
                        })
                    }
                }
            }) 
 
        },
        // 明细 
        getDtlList(idseq ){
            this.dtlData=[]
            this.jobDtl =[]
            this.t_loading =true
            //查工序明细
            getTabColOrData(this.v_url,'v_bs_bomjob','idseq',idseq,'corpid',this.v_corpid,'','',' order by jobnum,lstseq' ).then((res) => { 
                this.jobDtl =res.result 
                if (res.result.length>0){
                    this.v_idseq =res.result[0]['IDSEQ']
                    this.v_lstseq =res.result[0]['LSTSEQ']
                    getTabColOrData(this.v_url,'v_bs_bomdtl','idseq',idseq,'lstseq',this.v_lstseq,'','',' order by sortby,matno' ).then((res) => { 
                        this.dtlData =res.result 
                        res.result.forEach((item,index)=>{
                            item['SORTBY'] =index+1
                        })
                        this.$nextTick(() => { //有固定列时 查询后重新布局
                            this.$refs.refdtl.doLayout()
                            this.t_loading =false
                        }) 
                    })
                    this.$nextTick(() => { //有固定列时 查询后重新布局
                        this.$refs.refjob.doLayout();
                        this.$refs.refjob.setCurrentRow(res.result[0])
                    }) 
                }else{
                    this.t_loading =false
                }
            })         
        },
        //选择产品
        parentSel(){
            this.selPrdWin=true
        },
        prdSel(obj){
            let v_bool =false
            this.bomData.some(item=>{
                if (item['MATNO']==obj['MATNO']){
                    v_bool =true
                }
            })
            if (v_bool){
                this.promptWin =true
                this.prompt ='此产品已存在BOM ，请核查'
            }else{
                this.bomRow['MATNO']=obj['MATNO']
                this.bomRow['MATNM']=obj['MATNM']
                this.bomRow['MATTYNM']=obj['MATTYNM']
                this.bomRow['SPECNM']=obj['MATDESC']
                this.bomRow['UNITNM']=obj['UNITNM']
                this.selPrdWin=false
            }
        },
  
        //明细编辑、删除
        dtlDel(row,index){
            this.$confirm('确定要删除此物料吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{ 
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row['IDSEQ'],p_key2:'lstseq',p_value2:row['LSTSEQ'],p_key3:'itmseq',p_value3:row['ITMSEQ'],p_table:'BS_BOMDTL'},
                }).then((res)=>{
                    if (res.code=='200'){
                        this.dtlData.splice(index,1 )
                    }else{
                        this.promptWin=true
                        this.prompt=res.result
                    } 
                }) 
                
            }).catch((e)=>{

            })
        },
        //工序删除
        jobDel(row,index){
            let v_idseq =row.IDSEQ ,v_lstseq=row.LSTSEQ
            this.$confirm('删除此工序,同时也会把工序下的物料全删除,要继续吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:v_idseq,p_key2:'lstseq',p_value2:v_lstseq,p_table:'BS_BOMDTL'},
                }).then(res=>{ 
                    if (res.code=='200'){
                        //删除工序下的物料
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:v_idseq,p_key2:'lstseq',p_value2:v_lstseq,p_table:'BS_BOMJOB'},
                        }).then(res=>{
                            if (res.code=='200'){
                                this.jobDtl.splice(index,1) 
                                this.getDtlList(v_idseq)
                            }else{
                                this.promptWin=true
                                this.prompt =res.result
                            }
                        })       
                    }
                }).catch(res=>{
                    this.promptWin=true
                    this.prompt =res.result
                })
            }).catch((e)=>{

            })
        },
 
        //编辑记录
        editRec(row,val,index){
            if (val==='Y'){  //仅查看
                this.saveFlag=true
                this.qryJobMat =true
                this.v_joblst =row.IDSEQ
                this.getJobTree(row.IDSEQ)
                getTabColOrData(this.v_url,'v_bs_bomdtl','idseq',row['IDSEQ'],'','','','',' order by matno' ).then((res) => {         
                    this.matAll = res.result
                    this.$nextTick(()=>{
                        this.$refs['refqry'].doLayout()
                    })                  
                })
            }else{
                if (row.STFG==='Y'){
                    this.saveFlag=true
                }else{
                    this.saveFlag=false
                }   
 
                this.bomRow =JSON.parse(JSON.stringify(Object.assign(row,{IDSEQ:row.IDSEQ})))
                this.rowIdseq=row.IDSEQ
                //明细
                this.getDtlList(row.IDSEQ)
                this.addWin=true  
                this.$nextTick(()=>{
                    const tbody = document.querySelector('.draggable-table .el-table__body-wrapper tbody')
                    new Sortable(tbody, {
                        handle: '.handle', // handle's class
                        animation: 150,
                        // 需要在odEnd方法中处理原始eltable数据，使原始数据与显示数据保持顺序一致
                        onEnd: ({ newIndex, oldIndex }) => {
                            const targetRow = this.dtlData[oldIndex]
                            this.dtlData.splice(oldIndex, 1)
                            this.dtlData.splice(newIndex, 0, targetRow)
                        },
                    })
                })
            }   
        },
        //保存记录
        saveRec(){
            //发起保存请求   
            this.notNull.some(item=>{  //forEach 没找到跳出循环，some：return true 跳出lop ,every：return false 跳出
                if (!this.bomRow[item.FLDNO] ){
                    this.stfgBool =false 
                    this.promptWin=true
                    this.prompt=item.FLDNM+'不能为空'
                    return true
                }else{
                    this.stfgBool =true  
                }
            })
            //发起保存请求   
            if (this.stfgBool ) { 
                if(this.jobDtl.length>0) {
                    this.$axios({
                        method: 'post',
                        url:'xuper_auth/formOneSave',
                        data: {p_json:JSON.stringify(Object.assign(this.bomRow,{CORPID:this.v_corpid})), p_table:'BS_BOM',frmid:'15754'},
                    }).then(res=>{      
                        if(res.result ==='OK')  {  
                            let idseq_ =res.idseq
                            //1、明细保存：批量保存   
                            this.$axios({   
                                method: 'post',
                                url:'xuper_auth/batDtlSave2',
                                data: {p_json:JSON.stringify(this.jobDtl), p_table:'BS_BOMJOB',p_idseq:idseq_ , p_action:'S' },
                            }).then(res=>{
                                if (res.code!=='200'){
                                    this.promptWin=true
                                    this.prompt=res.result
                                }else{
                                  
                                    //表格查询  
                                    this.getBomList('')
                                    //主表
                                    getTabColOrData(this.v_url,'v_bs_bom','','','idseq',idseq_,'','','' ).then((res) => { 
                                        this.bomRow = res.result[0] 
                                    })
                                    //明细
                                    this.getDtlList(idseq_)
                                    this.$message({message: '工序已保存',type: 'success',center:true,duration:2000})
                                   
                                }
                            })  
                        }else{
                            if (res.result.indexOf('ORA-00001')>-1 ){
                                this.prompt ='系统已存在此产品的BOM，请核查'
                            }else{
                                this.prompt=res.result
                            }
                            this.promptWin=true   
                        }        
                    }) 
                }else{
                   this.prompt ='请导入工序'
                   this.promptWin=true 
                }
            }
        },
        //重新排序
        saveSort(){            
            this.jobDtl.sort((a,b)=>a['JOBNUM']-b['JOBNUM'])
            this.jobDtl.forEach((item,index)=>{
                item['JOBNUM'] =index+1
            })
            const v_confirm =this.jobDtl.map(async (item,index)=>{
                return await this.$axios({
                    method: 'post',
                    url:'xuper_auth/updateRec',
                    data: {p_key:'idseq',p_value:item['IDSEQ'],p_key2:'lstseq',p_value2:item['LSTSEQ'], p_table:'BS_BOMJOB',p_cond:' set jobnum='+item['JOBNUM'] },
                })
            })                 
            Promise.all(v_confirm).then(()=>{
                this.$message({message: '已保存排序',type: 'success',center:true,duration:2000})
            }) 
        },
        //新增
        addRec(){
            this.addWin=true
            this.dtlData=[]
            this.jobDtl =[]
            this.bomRow={BOMDTTM:getDate('day'),'IDSEQ':'',VER:'1','MATTY':'16225','BOMTY':'16212'}
 
        },
        jobAdd(){
            this.addJob =true
        },
        getRowKey(row){
            return row.IDSEQ
        },
        getDtlKey(row){
 
            return row.index
        },
        getItmKey(row){
            if (row.IDSEQ && row.LSTSEQ&& row.ITMSEQ)
            return row.IDSEQ+'-'+row.LSTSEQ+'-'+row.ITMSEQ
        },
        //状态变更
        stfgRec(row,val,index){
            let v_comm='' ,v_cond='', v_chkuser='',v_chkdttm=''
            if (val==='Y'){
                v_comm='审核'
            }else if (val==='N'){
                v_comm='弃审'
            }else if (val==='X'){
                v_comm='删除'
            }
            if (val=='Y'){
                v_chkuser =this.v_usernm
                v_chkdttm=getDate('full')
                v_cond =' set stfg=\''+val+'\' ,chkuser=\''+v_chkuser+'\',chkdttm=\''+v_chkdttm+'\''
            }else if (val=='X'){ //作废
                v_cond =' set stfg=\''+val+'\' ,chkuser=null,chkdttm=null,matno=\''+row['IDSEQ']+'\''
            }else{
                v_cond =' set stfg=\''+val+'\' ,chkuser=null,chkdttm=null'
            }
            this.$confirm('你确定要'+v_comm+'此单据吗?','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                type:'info',
            }).then(()=>{
                var vm=this
                this.$axios({   
                    method: 'post',
                    url:'xuper_auth/getBaseData',
                    data: {p_key:'bomno', p_value:row['IDNO'],p_key2:'corpid', p_value2:this.v_corpid, p_table:'V_prd_bomdtl'},
                }).then(res=>{ 
                    if (res.result.length>0 && val=='X'){
                        this.promptWin =true
                        this.prompt ='此单层BOM已被树状BOM引用，不能作废'
                    }else {
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/updateRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ,p_table:'BS_BOM',p_cond: v_cond},
                        }).then(res=>{      
                            if(res.code =='200')  {         
                                if (val =='X'){
                                    this.bomData.splice(index,1)
                                }else{  
                                    Object.assign(row,{STFGNM:v_comm ,STFG:val,CHKUSER:v_chkuser,CHKDTTM:v_chkdttm})
                                }
                            }else{
                                this.prompt=res.result
                                this.promptWin =true
                            }        
                        })
                    }
                })
            }).catch(()=>{})
             
        },
        delRec(row ,index){
            this.$confirm('你确定要删除此BOM吗','提示',{
                confirmButtonText: '确定',
                cancelButtonText:'取消',
                customClass:'messageBox',
                showClose:false,
                closeOnClickModal:false,
                closeOnPressEscape:false,
                type:'info',
            }).then(()=>{
                this.$axios({
                    method: 'post',
                    url:'xuper_auth/delTabRec',
                    data: {p_key:'idseq',p_value:row.IDSEQ ,p_table:'BS_BOMDTL'},
                }).then(res=>{ 
                    if(res.code==='200'){
                        this.$axios({
                            method: 'post',
                            url:'xuper_auth/delTabRec',
                            data: {p_key:'idseq',p_value:row.IDSEQ, p_table:'bs_bomjob'},
                        }).then(res=>{ 
                            if(res.code==='200'){
                                this.$axios({
                                    method: 'post',
                                    url:'xuper_auth/delTabRec',
                                    data: {p_key:'idseq',p_value:row.IDSEQ, p_table:'bs_bom'},
                                }).then(res=>{ 
                                    if(res.code==='200'){
                                        this.bomData.splice(index,1)
                                    }
                                })
                            }
                        })
                        
                    }
                })
            }).catch(()=>{})
        },
 
        goNext(){
            if (this.goPage){
                this.changePage(this.goPage)
                this.current =Number(this.goPage)
            }else{
                this.$alert('请输入跳至页数', '提示', {
                    confirmButtonText: '确定',
                    showClose:false,
                    type:'info'
                })
            }
        },
        //表格页面导航
        changePage(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.current =index
            this.bomData = this.allList.slice(_start,_end);
        },
        chgMat(index){
            var _start = ( index - 1 ) * this.rowSize;
            var _end = index * this.rowSize
            this.curpage =index
            this.matData = this.allMat.slice(_start,_end);
        },
        //初始化查询页条数
        initPage(){
            this.dataCount =this.allList.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allList.length < this.rowSize){
                this.bomData = this.allList          
            }else{
                if (this.current >1){
                    this.changePage(this.current)
                }else{
                    this.bomData =this.allList.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
                }
            }   
        },
        initMat(){
            this.recCount =this.allMat.length //总条数
            // 初始化显示，小于每页显示条数，全显，大于每页显示条数，取前每页条数显示
            if (this.allMat.length < this.rowSize){
                this.matData = this.allMat          
            }else{
                this.matData =this.allMat.slice(0,this.rowSize) //返回选定元素的子数组，不包含结尾元素
            }   
        },
        //bom单 
        getBomList(cond){
            let vm =this ,v_cond=''
            this.v_loading =true
            if (this.v_hide =='N'){
                v_cond =' and ishide=\'N\' '
            }else {
                v_cond =' and ishide=\'Y\' '
            }
            getTabColOrData(this.v_url,'v_bs_bom','','','CORPID',this.v_corpid,'','',cond+v_cond+' order by '+this.selparam+' desc' ).then((res) => { 
                this.allList =res.result 
                this.initPage() 
                this.$nextTick(() => { //有固定列时 查询后重新布局
                    this.$refs.refbom.doLayout()
                    this.v_loading =false
                }) 
            })
        },

        //获取表列头字段  v-enter-number
        getTabCol(){
            var vm=this
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15754','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.bomCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        sortable:res.result[k].SORTABLE, 
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16532','lstseq','6','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.matArr.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        disabled:res.result[k].DISABLED,
                        edcss:res.result[k].EDCSS,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15754','lstseq','2','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.dtlCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','15754','lstseq','3','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.jobObj.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM,
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','16521','lstseq','1','','',' order by sortby,lstseq' ).then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.jobCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                        edcss:res.result[k].EDCSS,
                        disabled:res.result[k].DISABLED,
                        dotnum:res.result[k].DOTNUM, 
                        sortable:res.result[k].SORTABLE,
                    })
                }
            })
            getTabColOrData(this.v_url,'v_sys_form_fld','idseq','4272','lstseq','1','','',' order by sortby,lstseq').then((res) => {
                for (let k=0; k<res.result.length; k++){
                    vm.prodCol.push({ //向数组的开头 添加序列号
                        title: res.result[k].title,
                        key: res.result[k].key,
                        align: res.result[k].align,
                        width: res.result[k].width,
                        edcss:res.result[k].EDCSS,
                        sortable:res.result[k].SORTABLE,
                        thide:res.result[k].THIDE,
                        fhide:res.result[k].FHIDE,
                    })
                }
            })
        },
    }
}
</script>
<style scoped lang="less">
    .handle {
        cursor: move;
        display: flex;
        align-content: center;
    }
    .item-width  {
        width: 24%;
        height:18px;
    }
    .item-width2  {
        width: 97%;
    }
    .pub_dialog {
        display: flex;
        justify-content: center;
        align-items: Center;
        overflow: hidden;
        .el-dialog {
            margin: 0 auto !important;
            height: 90%;
            overflow: hidden;
            .el-dialog__body {
                position: absolute;
                left: 0;
                top: 54px;
                bottom: 0;
                right: 0;
                padding: 0;
                z-index: 1;
                overflow: hidden;
                overflow-y: auto;
            }
        }
    }
</style>
<style lang="less">
    .custom-table-border .el-table__body td, .custom-table-border .el-table__header th {
        border-color: rgb(184, 181, 181);
        border-width: 1px;
    }
    .el-table {
        th {
            padding: 0 ;
        }
        thead{
            height: 15px;
            color:rgb(11, 11, 59);
            font-size:12px;
            background:rebeccapurple;
        }
        td {
            padding: 5px ;
            font-size:11px;
        } 
    }
    .el-dialog__body{
        padding: 2px;
    }
    .el-dialog__header{
        padding: 0px;
    }
    .el-dialog__footer{
        padding: 5px;
        border-top:1px solid #ccc;
    } 
    .el-dialog__headerbtn{font-size: 15px; background:white; }
    //.el-dialog__headerbtn i { background:white;font-size: 20px;  }
    .el-table .success-row {
        color:#959997;
    }
    .el-table .cancel-row {
        color: #e00e66;
    }
    .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
        border-color :#3d77eb;
    }
    .el-checkbox__input.is-disabled+span.el-checkbox__label{
        color:#3d77eb
    }
    .messageBox .el-message-box__content{
        border-top: 1px solid #EBEEF5;
        height: 50px;
    }
    .el-message-box__message p{
        line-height: 30px;
    }
    .messageBox .el-message-box__btns{
        padding: 20px 15px 0;
    }
    .messageBox .el-message-box__header{
        background:#409eff;
    }
    .messageBox .el-message-box__title{
        color:white ;
        font-size:14px;
    }
</style>